import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  BootstrapTable,
  InsertButton,
  TableHeaderColumn,
} from "react-bootstrap-table";
import { useHistory } from "react-router-dom";
import "../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { useHasRights } from "../../contexts/UserRightsContext";
import { useDataFormatterHook } from "../../hooks/useDataFormatterHook";
import InputSelect from "../common/InputSelect";
import Loader from "../common/loader/Loader";
import "./Players.css";

const statuses = [
  { value: "E", text: "Enabled" },
  { value: "D", text: "Disabled" },
];
const useStyles = makeStyles({
  root: {
    width: "100%",
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
  },
  tableHead: {
    background: "#3f51b5",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "darkcyan !important",
    },
  },

  tableRow: {
    "&:hover": {
      backgroundColor: "lightgrey !important",
    },
  },
  headerCell: {
    color: "white",
  },
});



function Players(props) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );
  const classes = useStyles();
  const [players, setPlayers] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState("E");

  let history = useHistory();


  const requestData = useCallback(() => {
    setIsLoading(true);
    const url =
      process.env.REACT_APP_API2_URL +
      "/Player/GetPlayerByStatus?status=" +
      filterStatus;
    axios
      .get(url)
      .then((response) => {
        setPlayers(Array.isArray(response.data) ? response.data : []);
      })
      .catch((err) => {
        console.error("Error loading players", err);
        setPlayers([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filterStatus]);

  // Initial Load
  useEffect(() => {
    requestData();
  }, [requestData]);

  const { formatter: lineTypesFormatter } = useDataFormatterHook({
    value: "idLineType",
    text: "description",
    path: "/LineType/GetLineTypes",
  });

  const { formatter: profilesFormatter } = useDataFormatterHook({
    value: "idProfile",
    text: "profileName",
    path: "/Player/GetPlayerProfile",
  });

  const { formatter: agentsFormatter } = useDataFormatterHook({
    value: "idAgent",
    text: "agent",
    path: `/Agent/Agent_GetList2Result?idUser=${userInfo.userId}`,
  });

  const handleStatusChange = useCallback((value) => {
    setFilterStatus(value);
  }, []);

  const statusFormatter = (value) =>
    value === "E" ? "Enabled" : value === "D" ? "Disabled" : value;

  function onAfterDeleteRow(rowKeys) {
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/Player/DeletePlayer?idPlayer=" +
        rowKeys +
        "&idUser=" +
        userInfo.userId,
    }).then((response) => { });
  }

  function customConfirm(next, dropRowKeys) {
    const dropRowKeysStr = dropRowKeys.join(",");
    if (
      window.confirm(
        `(It's a custom confirm)Are you sure you want to delete ${dropRowKeysStr}?`
      )
    ) {
      // If the confirmation is true, call the function that
      // continues the deletion of the record.
      next();
    }
  }

  function selectedValues(row) {
    history.push("/player/" + row.idPlayer);
  }

  const options = {
    page: 1, // which page you want to show as default
    sizePerPageList: [
      {
        text: "15",
        value: 15,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ], // you can change the dropdown list for size per page
    sizePerPage: 10, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 3, // the pagination bar size.
    prePage: "Prev", // Previous page button text
    nextPage: "Next", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: true, // Accept bool or function
    paginationPosition: "bottom", // default is bottom, top and both is all available
    afterDeleteRow: onAfterDeleteRow, // A hook for after droping rows.
    handleConfirmDeleteRow: customConfirm,
    onRowClick: selectedValues,
    afterInsertRow: onAfterInsertRow, // A hook for after insert rows
    insertBtn: () => {
      return (
        <InsertButton
          onClick={() => history.push("/player/0")}
        />
      );
    },
  };

  const cellEditProp = {
    mode: "click", //DBClick daba problemas con el Expand se cambio a click
    beforeSaveCell: onBeforeSaveCell, // a hook for before saving cell
    //afterSaveCell: onAfterSaveCell, // a hook for after saving cell
  };
  const selectRowProp = {
    mode: "checkbox",

    clickToSelect: true, // click to select, default is false
    clickToExpand: true, // click to expand row, default is false
  };

  function onAfterInsertRow(row) {
    let RequestDTO = {
      IdPlayer: row.IdPlayer,
      IdLineType: row.IdLineType,
      IdOffice: row.IdOffice,
      IdAgent: row.IdAgent,
      IdCurrency: row.IdCurrency,
      IdGrouping: row.IdGrouping,
      IdSource: 64,
      IdProfile: row.IdProfile,
      IdPlayerRate: row.IdPlayerRate,
      IdBook: row.IdBook,
      IdTimeZone: row.IdTimeZone,
      IdLanguage: row.IdLanguage,
      Player1: row.Player,
      Password: row.Password,
      Name: row.Name,
      LastName: row.LastName,
      LastName2: row.LastName2,
      Address1: "",
      Address2: "",
      City: "",
      State: "",
      Country: "",
      Zip: "",
      Phone: "",
      Fax: "",
      Email: "",
      CreditLimit: row.CreditLimit,
      TempCredit: row.TempCredit,
      OnlineAccess: row.OnlineAccess,
      OnlinePassword: row.OnlinePassword,
      OnlineMessage: row.OnlineMessage,
      OnlineMaxWager: row.OnlineMaxWager,
      OnlineMinWager: row.OnlineMinWager,
      MaxWager: row.MaxWager,
      MinWager: row.MinWager,
      ChartPercent: row.ChartPercent,
      Master: row.Master,
      FlagMessage: row.FlagMessage,
      IdFlagMessageType: row.IdFlagMessageType,
      DuplicatedBets: row.DuplicatedBets,
      DuplicatedBetsOnline: row.DuplicatedBetsOnline,
      SettledFigure: row.SettledFigure,
      ShowInTicker: row.ShowInTicker,
      EPOSPlayer: row.EPOSPlayer,
      EnableHorses: row.EnableHorses,
      EnableCasino: row.EnableCasino,
      EnableSports: row.EnableSports,
      DateOfBirth: row.DateOfBirth,
      SecQuestion: row.SecQuestion,
      SecAnswer: row.SecAnswer,
      SignUpIP: "192.168.3.20",
      HoldBets: row.HoldBets,
      HoldDelay: row.HoldDelay,
      IdProfileLimits: row.IdProfileLimits,
      EnableCards: row.EnableCards,
      IdAffiliate: row.IdAffiliate,
    };
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/Player/Player_Insert?IdUser=" +
        userInfo.userId,
      data: RequestDTO,
    }).then((response) => {
      requestData();
    });
  }

  function onBeforeSaveCell(row, cellName, cellValue) {
    return true;
  }
  const canDelete = useHasRights(307);

  return (
    <div id="main-div">
      <Paper className={`${classes.root} flex flex-col gap-4`}>
        <h2>Players</h2>
        {isLoading ? (
          <Loader></Loader>
        ) : (
          <>
            <InputSelect
              variant="outlined"
              size="small"
              label="Show"
              name="name"
              data={statuses}
              placeholder="DataFormatter"
              setSelectValue={handleStatusChange}
              startValue={filterStatus}
            />
            <Table className={classes.table}>
              <TableBody>
                {Array.isArray(players) && (
                  <div>
                    <BootstrapTable
                      pagination={true}
                      options={options}
                      cellEdit={cellEditProp}
                      selectRow={selectRowProp}
                      insertRow={true}
                      version="4"
                      data={players}
                      deleteRow={canDelete}
                      hover
                    >
                      <TableHeaderColumn
                        dataField="idPlayer"
                        hiddenOnInsert
                        isKey={true}
                        autoValue={true}
                      >
                        ID
                      </TableHeaderColumn>

                      <TableHeaderColumn
                        dataField="player"
                        filter={{ type: "TextFilter", delay: 1000 }}
                      >
                        Player
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="password"
                        filter={{ type: "TextFilter", delay: 1000 }}
                      >
                        Code
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="name"
                        filter={{ type: "TextFilter", delay: 1000 }}
                      >
                        Name
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="status"
                        dataFormat={statusFormatter}
                      >
                        Status
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="creditLimit">
                        Credit Limit
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="currentBalance">
                        Balance
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="amountAtRisk">
                        At Risk
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="idLineType"
                        dataFormat={lineTypesFormatter}
                      >
                        LineType
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="idAgent"
                        dataFormat={agentsFormatter}
                        filter={{ type: "TextFilter", delay: 1000 }}
                      >
                        Agent
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="idProfile"
                        dataFormat={profilesFormatter}
                        filter={{ type: "TextFilter", delay: 1000 }}
                      >
                        Profile
                      </TableHeaderColumn>
                    </BootstrapTable>
                  </div>
                )}
              </TableBody>
            </Table>
          </>
        )}
      </Paper>
    </div>
  );
}

export default Players;
